import * as Sentry from "@sentry/nextjs"
import { env } from "."

if (!env.isDev)
  Sentry.init({
    dsn: "https://41a13130dbb3616a72aaab2a5497e2c2@sentry.vibeapp.ru/14",

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,

    // Preserve restrictive v10 data collection behavior (v11 collects more by default)
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpBodies: [],
      databaseQueryData: false,
      genAI: { inputs: false, outputs: false },
    },

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    release: env.version,
  })

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
